var map = {
	"./symbol_0.png": 14490,
	"./symbol_1.png": 4323,
	"./symbol_10.png": 24555,
	"./symbol_11.png": 3426,
	"./symbol_2.png": 25992,
	"./symbol_3.png": 74385,
	"./symbol_4.png": 29822,
	"./symbol_5.png": 5607,
	"./symbol_6.png": 54924,
	"./symbol_7.png": 66549,
	"./symbol_8.png": 37394,
	"./symbol_9.png": 58939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93213;